import { ReactComponent as SilverIcon } from 'assets/icons/silver.svg';
import { ReactComponent as GoldIcon } from 'assets/icons/gold.svg';
import { ReactComponent as PlatinumIcon } from 'assets/icons/platinum-icon.svg';

export const LoyaltyIcons: any = {
	Silver: SilverIcon,
	Gold: GoldIcon,
	Platinum: PlatinumIcon,
};
